/*
 * Sunya real-user speed tracking.
 * Bundles Google's web-vitals library v6.2.1 (https://github.com/GoogleChrome/web-vitals),
 * Copyright Google LLC, licensed under the Apache License 2.0
 * (http://www.apache.org/licenses/LICENSE-2.0), followed by the store's own collector.
 * Loaded async from layout/theme.liquid only when Theme settings → Navigation & speed →
 * "Real-user speed tracking" is on.
 */
(function () {
  'use strict';
  if (window.__sunyaRumLoaded) return;
  window.__sunyaRumLoaded = true;
  var webVitals=function(t){"use strict";let n=-1;const e=()=>n,i=t=>{addEventListener("pageshow",e=>{e.persisted&&(n=e.timeStamp,t(e))},!0)},o=(t,n,e,i)=>{let o,s;return a=>{n.value>=0&&(a||i)&&(s=n.value-(o??0),(s||void 0===o)&&(o=n.value,n.delta=s,n.rating=((t,n)=>t>n[1]?"poor":t>n[0]?"needs-improvement":"good")(n.value,e),t(n)))}},s=t=>{requestAnimationFrame(()=>requestAnimationFrame(()=>t()))},a=()=>{const t=performance.getEntriesByType("navigation")[0];if(t&&t.responseStart>0&&t.responseStart<performance.now())return t},r=()=>a()?.activationStart??0;let c=-1;const f=new Set,h=()=>"hidden"!==document.visibilityState||document.prerendering?1/0:0,d=t=>{if("hidden"===document.visibilityState){if("visibilitychange"===t.type)for(const t of f)t();isFinite(c)||(c="visibilitychange"===t.type?t.timeStamp:0,removeEventListener("prerenderingchange",d,!0))}},l=(t=!1)=>{if(t&&(c=1/0),c<0){const t=r(),n=document.prerendering?void 0:globalThis.performance.getEntriesByType("visibility-state").find(n=>"hidden"===n.name&&n.startTime>=t)?.startTime;c=n??h(),addEventListener("visibilitychange",d,!0),addEventListener("prerenderingchange",d,!0),i(()=>{setTimeout(()=>{c=h()})})}return{get firstHiddenTime(){return c},onHidden(t){f.add(t)}}},g=(t,n=-1,i,o=0,s,c,f)=>{const h=a(),d=h?.navigationId||0;let l="navigate";i?l=i:e()>=0?l="back-forward-cache":h&&(document.prerendering||r()>0?l="prerender":document.wasDiscarded?l="restore":h.type&&(l=h.type.replace(/_/g,"-")));return{name:t,value:n,rating:"good",delta:0,entries:[],id:`v6-${Date.now()}-${Math.floor(8999999999999*Math.random())+1e12}`,navigationType:l,navigationId:o||d,navigationInteractionId:s,navigationURL:c||h?.name,navigationStartTime:f||0}},u=new WeakMap;function v(t,n){let e=u.get(n);return e||(e=new WeakMap,u.set(n,e)),e.get(t)||e.set(t,new n),e.get(t)}class m{t;i=0;o=[];h(t){if(t.hadRecentInput)return;const n=this.o[0],e=this.o.at(-1);this.i&&n&&e&&t.startTime-e.startTime<1e3&&t.startTime-n.startTime<5e3?(this.i+=t.value,this.o.push(t)):(this.i=t.value,this.o=[t]),this.t?.(t)}}const p=(t,n,e={})=>{try{const i=t.filter(t=>PerformanceObserver.supportedEntryTypes.includes(t));if(i.length>0){const t=new PerformanceObserver(t=>{queueMicrotask(()=>{const e=t.getEntries();i.length>1&&e.sort((t,n)=>t.startTime+t.duration-(n.startTime+n.duration)),n(e)})});for(const n of i)t.observe({type:n,buffered:!0,...e});return t}}catch{}},b=t=>globalThis.PerformanceObserver?.supportedEntryTypes?.includes("soft-navigation")&&"function"==typeof globalThis.PerformanceSoftNavigation?.prototype?.getLargestInteractionContentfulPaint&&t&&t.reportSoftNavs,T=(t,n)=>{if(t.set(n.navigationId,n),t.size>2){const n=t.keys().next().value;void 0!==n&&t.delete(n)}},y=t=>{let n=!1;return()=>{n||(t(),n=!0)}};class _{l}const E=t=>{document.prerendering?addEventListener("prerenderingchange",t,!0):t()},M=[1800,3e3],L=(t,n={})=>{const a=b(n);E(()=>{const c=v(n,_),f=l();let h,d=g("FCP");const u=p(["paint"],t=>{for(const n of t)"first-contentful-paint"===n.name&&(u.disconnect(),n.startTime<f.firstHiddenTime&&(d.value=Math.max(n.startTime-r(),0),d.entries.push(n),d.navigationId=n.navigationId||d.navigationId,h(!0)))});if(u&&(h=o(t,d,M,n.reportAllChanges),i(i=>{d=g("FCP",-1,"back-forward-cache",d.navigationId,d.navigationInteractionId,d.navigationURL,e()),h=o(t,d,M,n.reportAllChanges),s(()=>{d.value=performance.now()-i.timeStamp,h(!0)})})),a){p(["soft-navigation"],e=>{e.forEach(e=>{c.l&&e.navigationId&&T(c.l,e);const i=Math.max((e.presentationTime||e.paintTime||0)-e.startTime,0);d=g("FCP",i,"soft-navigation",e.navigationId,e.interactionId,e.name,e.startTime),h=o(t,d,M,n.reportAllChanges),h(!0)})},n)}})},w=[.1,.25];let P=0,I=1/0,k=0;const C=t=>{for(const n of t)n.interactionId&&(I=Math.min(I,n.interactionId),k=Math.max(k,n.interactionId),P=k?(k-I)/7+1:0)};let F;const N=()=>F?P:performance.interactionCount??0,B=()=>{"interactionCount"in performance||F||(F=p(["event"],C,{durationThreshold:0}))};class S{u=0;v=[];m=new Map;p;T;_(){return N()-this.u}M(){this.u=N(),this.v.length=0,this.m.clear()}L(t){const n=this._(),e=Math.min(this.v.length-1,Math.floor(n/50));return!n||-1!==e||"soft-navigation"!==t&&"back-forward-cache"!==t?this.v[e]:{P:8,id:-1,entries:[]}}h(t){if(this.p?.(t),!t.interactionId)return;const n=this.v.at(-1);let e=this.m.get(t.interactionId);if(e||this.v.length<10||t.duration>n.P){if(e?t.duration>e.P?(e.entries=[t],e.P=t.duration):t.duration===e.P&&t.startTime===e.entries[0].startTime&&e.entries.push(t):(e={id:t.interactionId,entries:[t],P:t.duration},this.m.set(e.id,e),this.v.push(e)),this.v.sort((t,n)=>n.P-t.P),this.v.length>10){const t=this.v.splice(10);for(const n of t)this.m.delete(n.id)}this.T?.(e)}}}const q=t=>{const n="requestIdleCallback"in globalThis?1e3:0,e=globalThis.requestIdleCallback||setTimeout,i=globalThis.cancelIdleCallback||clearTimeout;if("hidden"===document.visibilityState)t();else{const o=y(t);let s=-1;const a=()=>{i(s),o()};addEventListener("visibilitychange",a,{once:!0,capture:!0}),s=e(()=>{removeEventListener("visibilitychange",a,{capture:!0}),o()},{timeout:n})}},A=[200,500];class H{p;l;h(t){this.p?.(t)}}const O=[2500,4e3],U=[800,1800],V=t=>{document.prerendering?E(()=>V(t)):"complete"!==document.readyState?addEventListener("load",()=>V(t),!0):setTimeout(t)};return t.CLSThresholds=w,t.FCPThresholds=M,t.INPThresholds=A,t.LCPThresholds=O,t.TTFBThresholds=U,t.onCLS=(t,n={})=>{const a=l();L(y(()=>{let r,c=g("CLS",0);const f=v(n,m),h=(e,i,s,a,h)=>{c=g("CLS",0,e,i,s,a,h),f.i=0,r=o(t,c,w,n.reportAllChanges)},d=(t=!1)=>{f.i>c.value&&(c.value=f.i,c.entries=f.o),r(t)},l=t=>{d(!0),h("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime)},u=t=>{for(const n of t)"soft-navigation"!==n.entryType?f.h(n):l(n);d()},T=["layout-shift"];b(n)&&T.push("soft-navigation");const y=p(T,u);y&&(r=o(t,c,w,n.reportAllChanges),a.onHidden(()=>{u(y.takeRecords()),r(!0)}),i(()=>{h("back-forward-cache",c.navigationId,c.navigationInteractionId,c.navigationURL,e()),s(r)}),setTimeout(r))}))},t.onFCP=L,t.onINP=(t,n={})=>{if(!globalThis.PerformanceEventTiming||!("interactionId"in PerformanceEventTiming.prototype))return;const s=l();E(()=>{B();let a,r=g("INP");const c=v(n,S),f=(e,i,s,f,h)=>{c.M(),r=g("INP",-1,e,i,s,f,h),a=o(t,r,A,n.reportAllChanges)},h=()=>{const t=c.L(r.navigationType);t&&t.P!==r.value&&(r.value=t.P,r.entries=t.entries,a())},d=t=>{h(),a(!0),f("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime)},l=(t,n=!1)=>{q(()=>{for(const n of t)"soft-navigation"!==n.entryType?c.h(n):d(n);h(),n&&a(!0)})},u=["event","first-input"];b(n)&&u.push("soft-navigation");const m=p(u,l,{...n,durationThreshold:n.durationThreshold??40});a=o(t,r,A,n.reportAllChanges),m&&(s.onHidden(()=>{l(m.takeRecords(),!0)}),i(()=>{f("back-forward-cache",r.navigationId,r.navigationInteractionId,r.navigationURL,e())}))})},t.onLCP=(t,n={})=>{let a=!1;const c=b(n);E(()=>{let f,h=l(),d=g("LCP");const u=v(n,H),m=(e,i,s,r,c)=>{d=g("LCP",-1,e,i,s,r,c),f=o(t,d,O,n.reportAllChanges),a=!1,"soft-navigation"===e&&(h=l(!0))},b=t=>{u.l&&t.navigationId&&T(u.l,t),a||f(!0),m("soft-navigation",t.navigationId,t.interactionId,t.name,t.startTime);const n=t.getLargestInteractionContentfulPaint?.();n&&y([n])},y=t=>{n.reportAllChanges||c||(t=t.slice(-1));for(const n of t){if(!n)continue;if("soft-navigation"===n.entryType){b(n);continue}let t=0,e=[],i=n.startTime;if("largest-contentful-paint"===n.entryType)t=Math.max(n.startTime-r(),0),u.h(n),e=[n];else if("interaction-contentful-paint"===n.entryType){const o=n;if(!d.navigationId)continue;if("interactionId"in o&&o.interactionId!=d.navigationInteractionId)continue;i=o.largestContentfulPaint?.renderTime||0,t=Math.max(i-n.startTime,0),o.largestContentfulPaint&&(u.h(o.largestContentfulPaint),e=[o.largestContentfulPaint])}i<h.firstHiddenTime&&(d.value=t,d.entries=e,f())}},_=["largest-contentful-paint"];c&&_.push("interaction-contentful-paint","soft-navigation");const E=p(_,y);if(E){f=o(t,d,O,n.reportAllChanges);const r=["keydown","click","visibilitychange"],h=t=>{if(t.isTrusted&&!a){const t=d.id;q(()=>{if(!a){if(!c){E.disconnect();for(const t of r)removeEventListener(t,h,{capture:!0})}t===d.id&&(a=!0,f(!0))}})}};for(const t of r)addEventListener(t,h,{capture:!0});i(i=>{m("back-forward-cache",d.navigationId,d.navigationInteractionId,d.navigationURL,e()),f=o(t,d,O,n.reportAllChanges),s(()=>{d.value=performance.now()-i.timeStamp,a=!0,f(!0)})})}})},t.onTTFB=(t,n={})=>{const s=b(n);let c=g("TTFB"),f=o(t,c,U,n.reportAllChanges);V(()=>{const h=a();if(h){const a=h.responseStart;if(c.value=Math.max(a-r(),0),c.entries=[h],f(!0),i(()=>{c=g("TTFB",0,"back-forward-cache",c.navigationId,c.navigationInteractionId,c.navigationURL,e()),f=o(t,c,U,n.reportAllChanges),f(!0)}),s){p(["soft-navigation"],e=>{e.forEach(e=>{e.navigationId&&(c=g("TTFB",0,"soft-navigation",e.navigationId,e.interactionId,e.name,e.startTime),c.entries=[e],f=o(t,c,U,n.reportAllChanges),f(!0))})},n)}}})},t}({});

  /* ── Sunya real-user speed tracking ─────────────────────────────────────
     One record per page view, sent once when the page is hidden (tab switch,
     navigation, app switch) — the only moment LCP, INP and CLS are final.
     A page restored from the back/forward cache starts a fresh record.

     Where records go (any or all, whichever exist on the page):
       - GA4, as event 'sunya_web_vitals' with the main fields as parameters,
         through the page's gtag (see sendGa4 below);
       - Shopify.analytics.publish('sunya:web_vitals', record): a custom pixel
         in Settings → Customer events can subscribe and forward it to GA4;
       - window.dataLayer, as event 'sunya_web_vitals', for Google Tag Manager;
       - navigator.sendBeacon to the optional endpoint in theme settings.
     window.__sunyaRum keeps every record for debugging; add ?rum_debug=1 to a
     URL to see them in the console as well.

     Why not through GTM alone: the theme holds GTM back until the first
     interaction or 4 s, so the fast bounces and quick click-throughs this is
     meant to measure would mostly never be recorded. */
  var cfg = window.sunyaRumConfig || {};
  var nav = window.sunyaNav || {};
  var debug = /[?&]rum_debug=1/.test(location.search);
  var sent = false;
  var rec;

  function navEntry() { try { return performance.getEntriesByType('navigation')[0] || null; } catch (e) { return null; } }

  function landingOrInSite() {
    try {
      var act = window.navigation && navigation.activation;
      if (act) return act.from ? 'in-site' : 'landing';
    } catch (e) {}
    try { return document.referrer && new URL(document.referrer).origin === location.origin ? 'in-site' : 'landing'; } catch (e) { return 'landing'; }
  }

  function freshRecord(restored) {
    var ne = navEntry() || {};
    var conn = navigator.connection || {};
    return {
      v: 1,
      page: cfg.pageType || '',
      path: location.pathname,
      arrival: restored ? 'in-site' : landingOrInSite(),
      nav_type: restored ? 'back-forward-cache' : (ne.type || ''),
      delivery: restored ? '' : (ne.deliveryType || ''),
      modern: !!nav.modern,
      bucket: nav.bucket || '',
      in_app: !!nav.inApp,
      vt: '',
      hold: '', hold_ms: null, hold_from: null,
      device_memory: navigator.deviceMemory || 0,
      cores: navigator.hardwareConcurrency || 0,
      net: conn.effectiveType || '',
      save_data: !!conn.saveData,
      gtm_loaded: false,
      trackers_mode: '', trackers_by: '', trackers_at: null,
      ttfb: null, fcp: null, lcp: null, inp: null, cls: null,
      tap_to_nav: null, tap_to_fcp: null, tap_to_lcp: null,
      checkout_taps: 0, checkout_held: 0
    };
  }

  // The tap that led here, recorded on the previous page by snippets/nav-early.
  // Only trusted for an ordinary in-site navigation that started within 10 s
  // of it; anything else (reload, address bar, Back) is left blank.
  var tapAbs = null;
  (function () {
    var t = null;
    try { t = Number(sessionStorage.getItem('sunya-tap')); sessionStorage.removeItem('sunya-tap'); } catch (e) {}
    if (!t) return;
    var ne = navEntry();
    var gap = performance.timeOrigin - t;
    if (ne && ne.type === 'navigate' && gap >= 0 && gap < 10000 && landingOrInSite() === 'in-site') tapAbs = t;
  })();

  rec = freshRecord(false);
  if (tapAbs) rec.tap_to_nav = Math.round(performance.timeOrigin - tapAbs);

  function sinceTap(value) { return tapAbs ? Math.round(performance.timeOrigin + value - tapAbs) : null; }

  function onMetric(m) {
    var v = m.name === 'CLS' ? Math.round(m.value * 1000) / 1000 : Math.round(m.value);
    if (m.navigationType === 'back-forward-cache' && rec.nav_type !== 'back-forward-cache') {
      // A metric for a restored page arriving before pageshow reset the record.
      rec = freshRecord(true);
    }
    rec[m.name.toLowerCase()] = v;
    if (m.navigationType !== 'back-forward-cache') {
      if (m.name === 'FCP') rec.tap_to_fcp = sinceTap(m.value);
      if (m.name === 'LCP') rec.tap_to_lcp = sinceTap(m.value);
    }
  }

  /* GA4. Nothing else receives these records today: the GTM container has no
     tags, no pixel subscribes to sunya:web_vitals and the endpoint is empty.
     The Google & YouTube app's web pixel defines window.gtag in the page
     itself (a stub that queues into window.dataLayer) and loads gtag.js for
     the store's GA4 property, so the record goes through that gtag: it applies
     the consent state the app sets from Shopify's customer privacy, and it
     sends with fetch keepalive, so a record made while the page is being left
     still goes out. When the tab is only hidden, GA4 sends it with its next
     batch, about 5 s later, or when the tab is closed. transport_type is not
     passed: GA4 does not act on it and only forwarded it as one more
     parameter (ep.transport_type). send_to keeps the record away from the
     Google Ads tags configured on the same gtag; an ID that is not a GA4 one
     (G-...) is ignored for the same reason.
     GA4 keeps at most 25 parameters per event and 100 characters per text
     value, so these 23 fields are sent, plus sent_later (below). Left out:
     the path (GA4 has the page's own address), the record version, 'modern'
     (fixed by the theme settings outside a split test), cores, save_data,
     gtm_loaded and the tracker mode and trigger. Empty fields are left out
     rather than sent as blanks, and so is device_memory where the browser
     does not report it (Safari, Firefox) instead of sending 0; yes/no fields
     are sent as 1/0 so they can be averaged.

     Until GA4 has sent its first hit from a page, a record handed to gtag is
     lost if the page is left: the theme holds gtag.js back with the other
     trackers (the script interceptor in layout/theme.liquid) until the first
     interaction or 4 s, the app defines the stub 1-5 s into the page, and
     gtag.js needs a while more before it sends anything. In tests GA4's
     first hit came 5-7 s into a page on a desktop and 9-19 s on a phone with
     a 4x slower CPU; a page left before then lost its record, together with
     GA4's own page_view. Those are the fast bounces and click-throughs this
     is meant to measure, so such a record is kept in sessionStorage instead,
     with the page's own address and title and the time it was kept, and
     handed to gtag as soon as GA4 sends its first hit on a later page in
     this tab (or on this page, if it was only hidden). It goes with
     sent_later = 1 (0 otherwise), so the share of page views left before
     GA4 was sending can be read in GA4 too. sessionStorage belongs to the
     tab, so a bounce off the site is only sent if the visitor comes back to
     it in the same tab, and a record kept for more than 30 minutes (GA4's
     session timeout) is dropped rather than sent into a later session.
     Records are taken out of storage before they are handed over, so none
     is sent twice by one tab, and never after pagehide has run (at pagehide
     itself they go with the page's own record, before GA4 flushes): Chrome
     can still run a page for a moment after pagehide before freezing it in
     the back/forward cache, and a record handed over then would wait in
     GA4's frozen queue. A tab opened by script (window.opener set) starts
     with a copy of its opener's sessionStorage, so its first page drops the
     copied records and leaves them to the opener. Duplicate tab copies
     sessionStorage as well but leaves no such trace, so records kept when a
     tab is duplicated can be sent by both tabs: a rare, known double send
     (an id parameter to tell them apart would take the last free slot).
     Nothing is kept, and kept records are dropped unsent, when Shopify's
     customer privacy API says analytics is not allowed for this visitor;
     the page's own record still goes to gtag, which applies consent itself.
     The API only arrives some seconds into a page (3-6 s on a desktop in
     tests, after gtag.js on a slow phone) and nothing is checked before it
     does; what reaches gtag is still subject to the consent state the app
     gives it.
     GA4 counts as sending once a request for this ID to /g/collect, or to a
     first-party path ending in /g/c (Google tag gateway, e.g. /ag/g/c),
     appears in Resource Timing, or else once gtag.js for this ID
     (window.google_tag_manager[ID]) has existed for 3 s without one being
     seen, as WebKit may leave GA4's keepalive requests out of Resource
     Timing. In Chrome tests the first hit started as gtag.js arrived on a
     desktop and up to 3.3 s after it on a phone with a 4x slower CPU; the
     check runs once a second, so the fallback comes about 3-4 s after
     gtag.js. */
  var GA4_FIELDS = ['page', 'arrival', 'nav_type', 'delivery', 'bucket', 'in_app', 'vt',
    'hold', 'hold_ms', 'hold_from', 'net', 'device_memory',
    'ttfb', 'fcp', 'lcp', 'inp', 'cls', 'tap_to_nav', 'tap_to_fcp', 'tap_to_lcp',
    'checkout_taps', 'checkout_held', 'trackers_at'];
  var GA4_KEEP = 'sunya-rum-ga4';
  var GA4_KEEP_MS = 30 * 60 * 1000;
  var ga4Id = String(cfg.ga4 || '').trim().toUpperCase();
  if (!/^G-[A-Z0-9]+$/.test(ga4Id)) ga4Id = '';
  var ga4Hit = ga4Id ? new RegExp('/g/c(ollect)?\\?(.*&)?tid=' + ga4Id + '(&|$)') : null;
  var ga4Live = false;
  var ga4Watch = null;
  var ga4Poll = 0;
  var ga4TagAt = 0;
  var leaving = false;

  // False when Shopify's customer privacy API is on the page and says the
  // visitor has not allowed analytics (declined, or not yet chosen where the
  // law asks for a choice), or when asking it fails.
  function ga4Allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false);
    } catch (e) { return false; }
  }

  // Kept records, without the ones kept more than 30 minutes ago.
  function ga4Kept() {
    try {
      var list = JSON.parse(sessionStorage.getItem(GA4_KEEP) || '[]');
      var now = Date.now();
      return Array.isArray(list) ? list.filter(function (p) { return p && p.kept_at <= now && now - p.kept_at < GA4_KEEP_MS; }) : [];
    } catch (e) { return []; }
  }

  function ga4SendKept() {
    var list = ga4Kept();
    try { sessionStorage.removeItem(GA4_KEEP); } catch (e) { return; }
    if (!ga4Allowed()) return;
    for (var i = 0; i < list.length; i++) {
      delete list[i].kept_at;
      list[i].send_to = ga4Id;
      window.gtag('event', 'sunya_web_vitals', list[i]);
    }
  }

  function ga4Seen(entries) {
    for (var i = 0; i < entries.length; i++) if (ga4Hit.test(entries[i].name)) return true;
    return false;
  }

  function ga4Went() {
    ga4Live = true;
    try { ga4Watch.disconnect(); } catch (e) {}
    clearInterval(ga4Poll);
    if (!leaving && typeof window.gtag === 'function') try { ga4SendKept(); } catch (e) {}
  }

  // The fallback: gtag.js for this ID has been on the page for 3 s and no
  // GA4 hit has been seen.
  function ga4TagCheck() {
    var m = window.google_tag_manager;
    if (ga4Live || !(m && m[ga4Id])) return;
    if (!ga4TagAt) {
      ga4TagAt = Date.now();
      clearInterval(ga4Poll);
      setTimeout(function () { if (!ga4Live) ga4Went(); }, 3000);
    } else if (Date.now() - ga4TagAt >= 3000) ga4Went();
  }

  if (ga4Id) {
    // The first page of a tab opened by script holds copies of its opener's
    // records (see above).
    if (window.opener && history.length === 1) try { sessionStorage.removeItem(GA4_KEEP); } catch (e) {}
    try {
      if (PerformanceObserver.supportedEntryTypes.indexOf('resource') > -1) {
        ga4Watch = new PerformanceObserver(function (list) { if (!ga4Live && ga4Seen(list.getEntries())) ga4Went(); });
        ga4Watch.observe({ type: 'resource', buffered: true });
      }
    } catch (e) { ga4Watch = null; }
    // gtag.js is looked for once a second for the page's first 2 minutes;
    // after that only when a record is made (ga4Ready).
    var polls = 0;
    ga4Poll = setInterval(function () { if (++polls > 120) clearInterval(ga4Poll); else ga4TagCheck(); }, 1000);
  }

  function ga4Ready() {
    if (!ga4Live && ga4Watch) try { if (ga4Seen(ga4Watch.takeRecords())) ga4Went(); } catch (e) {}
    if (!ga4Live) ga4TagCheck();
    return ga4Live && typeof window.gtag === 'function';
  }

  function sendGa4(out) {
    if (!ga4Id) return;
    var params = {};
    for (var i = 0; i < GA4_FIELDS.length; i++) {
      var k = GA4_FIELDS[i], v = out[k];
      // device_memory is 0 where the browser does not report it.
      if (v === null || v === undefined || v === '' || (k === 'device_memory' && !v)) continue;
      if (typeof v === 'boolean') v = v ? 1 : 0;
      else if (typeof v === 'string') v = v.slice(0, 100);
      params[k === 'page' ? 'page_type' : k] = v;
    }
    if (ga4Ready()) {
      ga4SendKept();
      params.sent_later = 0;
      params.send_to = ga4Id;
      window.gtag('event', 'sunya_web_vitals', params);
      return;
    }
    if (!ga4Allowed()) return;
    params.sent_later = 1;
    params.page_location = location.origin + location.pathname;
    params.page_title = document.title.slice(0, 100);
    params.kept_at = Date.now();
    var list = ga4Kept();
    list.push(params);
    try { sessionStorage.setItem(GA4_KEEP, JSON.stringify(list.slice(-10))); } catch (e) {}
  }

  function flush() {
    if (sent) return;
    sent = true;
    rec.vt = (window.sunyaNav && window.sunyaNav.vt) || '';
    // How the first-paint hold ended (snippets/paint-hold.liquid): 'on',
    // 'parse-end', 'capped' (the time cap ran out on a page that had arrived
    // in time), 'late-commit' (the page itself only arrived after the cap and
    // was held just until its content started, for a moment at most: a slow
    // server or phone, not a tight cap, so count these apart when tuning it)
    // or 'off'.
    rec.hold = rec.nav_type === 'back-forward-cache' ? '' : ((window.sunyaNav && window.sunyaNav.hold) || '');
    // When the held page appeared: its first paint (snippets/paint-hold.liquid),
    // no longer the first animation frame, which came 0.1-1.3 s earlier on
    // phones, before that frame had been laid out and painted.
    if (rec.hold && rec.hold !== 'off' && window.sunyaNav && window.sunyaNav.holdMs) rec.hold_ms = window.sunyaNav.holdMs;
    // When the hold began (the new page's commit): the cap is counted from
    // here (snippets/paint-hold.liquid), so hold_ms - hold_from is the wait
    // the cap governs and hold_from the part spent before this page existed.
    if (rec.hold && rec.hold !== 'off' && window.sunyaNav && window.sunyaNav.holdFrom != null) rec.hold_from = window.sunyaNav.holdFrom;
    rec.gtm_loaded = !!(window.google_tag_manager);
    var tr = window.sunyaTrackers;
    if (tr) { rec.trackers_mode = tr.mode || ''; rec.trackers_by = tr.by || ''; rec.trackers_at = tr.released ? tr.at : null; }
    var out = JSON.parse(JSON.stringify(rec));
    (window.__sunyaRum = window.__sunyaRum || []).push(out);
    if (debug) try { console.log('[sunya-rum]', out); } catch (e) {}
    try { sendGa4(out); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('sunya:web_vitals', out); } catch (e) {}
    try { var gl = window.sunyaGtmLayer; if (gl) (window[gl] = window[gl] || []).push({ event: 'sunya_web_vitals', sunya_web_vitals: out }); } catch (e) {}
    if (cfg.endpoint && navigator.sendBeacon) {
      try { navigator.sendBeacon(cfg.endpoint, new Blob([JSON.stringify(out)], { type: 'text/plain' })); } catch (e) {}
    }
  }

  // Checkout taps on rupee pages, from snippets/razorpay-magic-guard.liquid.
  // checkout_held counts the ones that came before Razorpay Magic was ready.
  addEventListener('sunya:checkout-tap', function (e) {
    rec.checkout_taps += 1;
    if (e.detail && e.detail.held) rec.checkout_held += 1;
  });

  addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); }, true);
  addEventListener('pagehide', function () { leaving = true; flush(); }, true);
  addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    leaving = false;
    sent = false;
    tapAbs = null;
    rec = freshRecord(true);
  }, true);

  var opts = { reportAllChanges: true };
  webVitals.onTTFB(onMetric, opts);
  webVitals.onFCP(onMetric, opts);
  webVitals.onLCP(onMetric, opts);
  webVitals.onINP(onMetric, opts);
  webVitals.onCLS(onMetric, opts);

})();
